import { render, staticRenderFns } from "./ecobox-order-list.vue?vue&type=template&id=35bb4440&"
import script from "./ecobox-order-list.vue?vue&type=script&lang=js&"
export * from "./ecobox-order-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports